//Intro Showcase Images
import narutoShowcase from "./assets/nwebsitess.png";
import pongShowcase from "./assets/pongGame.png";
import worldeShowcase from "./assets/wordleclone.png";
import atonementShowcase from "./assets/atonementTitleScreen.png";
import bookLoggerShowcase from "./assets/booklogger.png";


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faDatabase} from '@fortawesome/free-solid-svg-icons'
import {faReact, faGit,faSass,faHtml5,faNode,faUnity,faCss3Alt} from '@fortawesome/free-brands-svg-icons'


export const featuredPortfolio = [
    {
        id: 1,
        title: "Booklogger Website",
        techStack1: <FontAwesomeIcon icon={faDatabase}/>,
        techStack2: <FontAwesomeIcon icon={faReact} />,
        techStack3: <FontAwesomeIcon icon={faNode} />,
        img: bookLoggerShowcase,
        codeLink:"https://github.com/p2557506/book-logger",
        liveLink:"https://book-logger.netlify.app/",
        desc:"Full-Stack Application (SERN) that allows the user to track the books they're reading, have read and want to read. Functioning register and login processes that incorporate both authorization and authentication.",
    },
    {
        id: 2,
        title: "Naruto World Website",
        techStack1: <FontAwesomeIcon icon={faReact} />,
        techStack2: <FontAwesomeIcon icon={faHtml5} />,
        techStack3: <FontAwesomeIcon icon={faSass} />,
        img: narutoShowcase,
        codeLink:"https://github.com/p2557506/naruto-app",
        desc:"Website that lets user explore character abilities, backstories, clans, villages, tailed beasts and established teams that make up the amazing Naruto universe!"
    },
    {
        id: 3,
        title: "PONG Arcade Game",
        techStack1: <FontAwesomeIcon icon={faUnity} />,
        techStack2: "",
        techStack3: "",
        img: pongShowcase,
        codeLink: "",
        desc:"2D sports game simulating table tennis. Have fun playing against computer ai or another player. First to 7 wins! "
    },
    {
        id: 4,
        title: "Atonement",
        techStack1: <FontAwesomeIcon icon={faUnity} />,
        techStack2: "",
        techStack3: "",
        img:  atonementShowcase,
        codeLink:"https://github.com/p2557506/2D-Platformer-Game-Ghost-Vania",
        desc:"2D Platformer game with 3 distinct base levels and a final boss stage for the player to beat! Contains unique enemy types, platforming oppurtunities and collectibles"
    },
    {
        id: 5,
        title: "Wordle Clone",
        techStack1: <FontAwesomeIcon icon={faReact} />,
        techStack2: <FontAwesomeIcon icon={faHtml5} />,
        techStack3: <FontAwesomeIcon icon={faCss3Alt} />,
        img: worldeShowcase,
        codeLink:"https://github.com/p2557506/wordle-clone",
        desc:"App clone that mimics the functionality of the famous Wordle Game. Figure out the secret five letter word within 6 guesses"
    },
    
]
export const webPortfolio = [
    {
        id: 1,
        title: "Booklogger Website",
        techStack1: <FontAwesomeIcon icon={faDatabase}/>,
        techStack2: <FontAwesomeIcon icon={faReact} />,
        techStack3: <FontAwesomeIcon icon={faNode} />,
        img: bookLoggerShowcase,
        codeLink:"https://github.com/p2557506/2D-Platformer-Game-Ghost-Vania",
        desc:"Full-Stack Application (SERN) that allows the user to track the books they're reading, have read and want to read. Functioning register and login processes that incorporate both authorization and authentication"
    },
    {
        id: 2,
        title: "Naruto World Website",
        techStack1: <FontAwesomeIcon icon={faReact} />,
        techStack2: <FontAwesomeIcon icon={faHtml5} />,
        techStack3: <FontAwesomeIcon icon={faSass} />,
        img: narutoShowcase,
        codeLink:"https://github.com/p2557506/naruto-app",
        desc:"Website that lets user explore character abilities, backstories, clans, villages, tailed beasts and established teams that make up the amazing Naruto universe!"
    },
    {
        id: 3,
        title: "Wordle Clone",
        techStack1: <FontAwesomeIcon icon={faReact} />,
        techStack2: <FontAwesomeIcon icon={faHtml5} />,
        techStack3: <FontAwesomeIcon icon={faCss3Alt} />,
        img: worldeShowcase,
        codeLink:"https://github.com/p2557506/wordle-clone",
        desc:"App clone that mimics the functionality of the famous Wordle Game. Figure out the secret five letter word within 6 guesses"
    },
    
    
]
export const gamePortfolio = [
    {
        id: 1,
        title: "PONG Arcade Game",
        techStack1: <FontAwesomeIcon icon={faUnity} />,
        techStack2: "",
        techStack3: "",
        img: pongShowcase,
        codeLink:"",
        desc:"2D sports game simulating table tennis. Have fun playing against computer ai or another player. First to 7 wins! "
    },
    {
        id: 2,
        title: "Atonement",
        techStack1: <FontAwesomeIcon icon={faReact} />,
        techStack2: <FontAwesomeIcon icon={faHtml5} />,
        techStack3: <FontAwesomeIcon icon={faSass} />,
        img: atonementShowcase,
        codeLink:"https://github.com/p2557506/2D-Platformer-Game-Ghost-Vania",
        desc:"2D Platformer game with 3 distinct base levels and a final boss stage for the player to beat! Contains unique enemy types, platforming oppurtunities and collectibles"
    },
    {
        id: 5,
        title: "Wordle Clone",
        techStack1: <FontAwesomeIcon icon={faReact} />,
        techStack2: <FontAwesomeIcon icon={faHtml5} />,
        techStack3: <FontAwesomeIcon icon={faCss3Alt} />,
        img: worldeShowcase,
        codeLink:"https://github.com/p2557506/wordle-clone",
        desc:"App clone that mimics the functionality of the famous Wordle Game. Figure out the secret five letter word within 6 guesses"
    },
    
]
export const mobilePortfolio = [
    
    
    
]


      